module.exports = __webpack_public_path__ + "media/hyper/images/bg-auth-f76f8d6668072c80528868ff122e1680.jpg";